<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  icon: { type: String, required: true },
  title: { type: String, required: true },
  description: { type: String, default: '' },
  actionLabel: { type: String, default: '' },
});

const emit = defineEmits(['action']);
</script>

<template>
  <div
    class="flex flex-col items-center gap-3 rounded-xl border border-dashed border-n-weak px-6 py-12 text-center"
  >
    <span
      class="grid size-12 place-items-center rounded-xl bg-n-alpha-2 text-n-slate-11"
      aria-hidden="true"
    >
      <Icon :icon="icon" class="size-6" />
    </span>
    <h2 class="mb-0 text-base font-semibold text-n-slate-12">{{ title }}</h2>
    <p
      v-if="description"
      class="mb-0 max-w-md text-sm leading-relaxed text-n-slate-11"
    >
      {{ description }}
    </p>
    <Button
      v-if="actionLabel"
      icon="i-hugeicons-add-01"
      :label="actionLabel"
      class="mt-1"
      @click="emit('action')"
    />
  </div>
</template>
